/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const productGrid = {
  productGrid: {
    length: 'Largo (mm)',
    packetWeight: 'Peso del Paquete (kg)',
    sheetsWeight: "Paquete de aprox.",
    sheetsByPackage: "Chapas / Paquete",
    quantity: 'Cantidad de Paquetes',
    quantityLabel: 'Introduzca la cantidade de PAQUETES deseados',
    outOfStock: 'Agotado',

    error:{
      minimumWeight: 'Peso mínimo {{minWeight}} Kg',
      maximumWeight: 'Peso máximo {{maxWeight}} Kg',
      quantity: 'Por favor, introduzca una cantidad valida',
      length: 'Por favor, introduzca un largo válido',
    }
  },

};
